import { render, staticRenderFns } from "./RepositoryBranchSelector.vue?vue&type=template&id=068bb93a&scoped=true&"
import script from "./RepositoryBranchSelector.vue?vue&type=script&lang=js&"
export * from "./RepositoryBranchSelector.vue?vue&type=script&lang=js&"
import style0 from "./RepositoryBranchSelector.vue?vue&type=style&index=0&id=068bb93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068bb93a",
  null
  
)

export default component.exports